export const environment = {
    production: false,
    firebaseConfig: {
      apiKey: "AIzaSyBbisXJs3CwkTLcHpuOfPTDVvHZZdffYAI",
      authDomain: "randomchat-c9bfa.firebaseapp.com",
      projectId: "randomchat-c9bfa",
      storageBucket: "randomchat-c9bfa.firebasestorage.app",
      messagingSenderId: "922220679671",
      appId: "1:922220679671:web:8f180ba7b5a2b0e20b9ef2",
      measurementId: "G-0CL1C0870X"
    }
  };
  